import { sendGTMEvent } from '@next/third-parties/google';
import { captureException } from '@sentry/nextjs';

import { getBrowserId } from '@/general/components/Analytics/Analytics.helpers';
import { pushCarmaEvent } from '@/general/helpers/carmaCritical';
import { hashStringArrayToStableId } from '@/general/helpers/hashStringArrayToStableId';

export type PushToDataLayerData = { event: string } & Record<string, unknown>;

/**
 * Configuration object for the pushToDataLayer function.
 * `sendToCDP` is only valid when `eventIdComponents` is set (stable event id path).
 */
export type PushToDataLayerConfig =
  | {
      /** array of strings to be used as components of the event ID */
      eventIdComponents: string[];
      /** optional boolean to send the event to CDP */
      sendToCDP?: boolean;
    }
  | {
      eventIdComponents: undefined;
      sendToCDP?: never;
    };

/**
 * Push data to GTM's data layer
 */
export const pushToDataLayer = (data: PushToDataLayerData, config?: PushToDataLayerConfig) => {
  if (config?.eventIdComponents) {
    hashStringArrayToStableId([...config.eventIdComponents, getBrowserId()])
      .then((eventId) => {
        sendGTMEvent({ ...data, eventId });
        if (config.sendToCDP) {
          pushCarmaEvent({
            event: 'reconciliation',
            metadata: { eventId, eventName: data.event, eventIdComponents: config.eventIdComponents },
          });
        }
      })
      .catch((error) => {
        captureException(error);
        console.error('Error hashing event ID:', error);
      });
  } else {
    sendGTMEvent(data);
  }
};
